import React, { type ReactNode } from 'react';
import classNames from 'classnames';
import type { GetProps } from '@types';
import ToggleButton from './ToggleButton';

type Props = Pick<GetProps<typeof ToggleButton>, 'isOn' | 'onToggle'> & {
  title: ReactNode;
  className?: string;
};

function FeatureToggle({ title, className, isOn, onToggle }: Props) {
  return (
    <div
      className={classNames(
        'mt-20 flex items-center justify-between',
        className
      )}
    >
      {title}
      <ToggleButton isOn={isOn} onToggle={onToggle} />
    </div>
  );
}

export default FeatureToggle;
